export default __webpack_public_path__ + "static/media/dv.a8daf64e.svg";